import React from "react";
import { Typography } from "@creditsafe/ui-components";
import { CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const GridWrapper = styled(Grid)`
  height: 90vh;
`;

const GridProgress = styled(Grid)`
  padding-top: 16px;
`;

const LoginPageLoader: React.FC = () => {
  const { t: translate } = useTranslation(["common"]);

  return (
    <GridWrapper
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <Grid item>
        <img
          src={require("../assets/cslogo.svg")}
          alt="Creditsafe Logo"
          width="198px"
          height="50px"
        />
      </Grid>
      <Grid item>
        <Typography variant={"h5"}>
          {translate("common:signingYouIn")}...
        </Typography>
      </Grid>
      <GridProgress item>
        <CircularProgress />
      </GridProgress>
    </GridWrapper>
  );
};

export default LoginPageLoader;
